'use strict';

exports.__esModule = true;
exports.default = createApolloSocketLink;

var _apolloLinkWs = require('apollo-link-ws');

var _utils = require('../utils');

var _graphFetchWrapper = require('./graph-fetch-wrapper');

function createApolloSocketLink(_ref) {
  var uri = _ref.uri;

  var socketLink = new _apolloLinkWs.WebSocketLink({
    uri: uri,
    options: {
      reconnect: true,
      connectionParams: _utils.includeAuthHeader
    }
  });
  socketLink.connectionCallback = function (response) {
    return (0, _graphFetchWrapper.isUnauthorisedResponse)(response) && socketLink.close();
  };
  return socketLink;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/network/graph-client/link-socket-apollo.js
// module id = 1162
// module chunks = 0